import { reverseMedikreditClaim } from "../../mediKreditapi";

/**
 * Reverse a processed claim at the switch.
 *
 * This no longer rebuilds the claim from the live invoice. The spec's
 * reversal is the original claim replayed verbatim under the same
 * transaction number with tx_cd 11 / msg_fmt 16, and the invoice drifts
 * after submission (liability shifts, edits), so the backend replays the
 * stored original request instead: /soap/reversal loads the claimRequest
 * blob, flips the attributes and enforces the golden rules (an
 * upfront-rejected or all-items-rejected claim is never reversed; an
 * already-reversed claim stays reversed). Refusals surface as 404/422 with
 * a user-facing message.
 *
 * The signature keeps the old call shape; only practice, invoice and
 * claimtxn are used.
 */
export async function ReverseClaim({ practice, invoice, claimtxn }) {
  return reverseMedikreditClaim(
    { sp_bhf: practice?.practiceNumber },
    claimtxn,
    invoice?._id,
  );
}
